var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-light tool-input-button",on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }